import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: "General",
    showItem: true,
    icon: "bx-store",
    subItems: [
      {
        id: 15,
        label: "Cupones",
        link: "/cupons",
        parentId: 1,
        code: "CUP000",
        showItem: true,
      },
    ],
  },
];
